module.exports = __webpack_public_path__ + "img/my_car.asm.84c2d813.jpg";